/**
 * Flatten nested UI copy (strings only) for read-aloud. Skips URLs and huge blobs.
 */
export function collectUiStringsForTts(root, { maxPieces = 160, maxPieceLen = 480 } = {}) {
  const out = [];
  const walk = (v) => {
    if (out.length >= maxPieces) return;
    if (typeof v === "string") {
      const s = v.trim();
      if (!s || s.length > maxPieceLen) return;
      if (/^https?:\/\//i.test(s)) return;
      out.push(s);
      return;
    }
    if (Array.isArray(v)) {
      v.forEach(walk);
      return;
    }
    if (v && typeof v === "object") {
      Object.values(v).forEach(walk);
    }
  };
  walk(root);
  return out.join(" ");
}
